import request from './adminRequest'

export const commentApi = {
  listComment (params) {
    return request.get('/comments', { params: params })
  },
  getComment (commentId) {
    return request.get('/comments/' + commentId)
  },
  saveComment (data) {
    return request.post('/comments/', data)
  },
  updateComment (commentId, data) {
    return request.put(`/comments/${commentId}`, data)
  },
  deleteComment (commentId) {
    return request.delete('/comments/' + commentId)
  },

}
export default commentApi
